import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//helpers
import { screen } from '@/helpers/screen';

export const ListsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0 clamp(32px, 5vw, 64px);
  margin-top: var(--gap-h2, 56px);

  ${screen.lg} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  ul {
    margin: 0;
    max-width: 36em;
    padding-left: 22.4px;
    font-size: 18px;
    line-height: 1.75;
    list-style: disc;
    color: rgb(${getToken('color-text-primary')});
  }

  li {
    margin: 4px 0;
    padding-left: 4px;
    font-family: ${getToken('font-family-default')};
    color: rgb(${getToken('color-text-primary')});
  }
`;
